import * as React from 'react';



import { Progress } from 'reactstrap';

const UploadProgress = ({status, progress}) => {
  const color = {
    uploading: 'primary',
    complete: 'success',
    error: 'danger',
  }[status]

  const animated = (status == 'uploading');

  const label = {
    uploading: `Uploading... ${progress}%`,
    complete: 'Complete',
    error: 'There was an error',
  }[status]
  
  return (
    <Progress animated={animated} 
      className="mt-2"
      color={color} 
      value={progress}> 
      {label}
    </Progress>
  );
}

const imgContainerStyle = {
  position: 'relative',
  overflow:'hidden',
  paddingBottom: '100%',
}

const imgStyle =  {
    position: 'absolute',
    maxWidth: '100%',
    maxHeight: '100%',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
}

import { Card, Button } from 'reactstrap';

const removeBtnStyle = {
  position: 'absolute',
  top: 10,
  right: 10,
}

const PhotoUpload = ({
  name, 
  imageData, 
  status, 
  progress,
  token, 
  onRemove
}) => {
  return (
    <div className="col-lg-3 col-md-4 col-sm-6" style={{minWidth: 300}}> 
      <Card body={true} outline>
        <div style={imgContainerStyle}>
          <img src={imageData} className="img-fluid full-width" 
            style={imgStyle} />
        </div>
        
        <UploadProgress  status={status} progress={progress} />
        
        { token && <Button 
            style={removeBtnStyle}
            color="danger"
            size="sm"
            onClick={onRemove}>Remove</Button> }
      </Card>
    </div>
  )
}

export default PhotoUpload;
